module.exports = __webpack_public_path__ + "img/yhFIr.fac959f0.png";